<script>
  export default {
    name: "NoFoundData",
    props: ["icon", "title", "subtitle"],
  };
</script>

<template>
  <div class="noFoundData">
    <div class="noFoundData__iconContainer">
      <iconic :name="icon" class="noFoundData__icon" />
    </div>
    <div class="noFoundData__textContainer">
      <p class="noFoundData__title">{{ title }}</p>
      <p class="noFoundData__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<style lang="scss">
  .noFoundData {
    @include Flex(column, center, center);
    position: absolute;
    padding: 20px;
    top: 27%;
    left: 50%;
    width: 95%;
    transform: translate(-50%, -50%);
    text-align: center;
    gap: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 5px #d8d8d8;

    &__iconContainer {
      @include Flex();
      padding: 22px;
      border-radius: 50%;
      background-color: #f2f4f7;
    }
    &__icon {
      font-size: 30px;
      color: #99a1b0;
    }
    &__textContainer {
      @include Flex(column, center, center);
      gap: 8px;
    }
    &__title {
      font-size: 18px;
      font-weight: 600;
      font-family: $newFont;
      color: #3d3d3d;
    }
    &__subtitle {
      font-size: 16px;
      font-weight: 400;
      font-family: $newFont_regular;
      color: #3d3d3d;
    }
  }
</style>
